export default "__VITE_ASSET__pRlv9h6D__"